import { Box, useTheme } from "@mui/material";

interface ClientLogoCardProps {
  image: string;
  name?: string;
}

const ClientLogoCard: React.FC<ClientLogoCardProps> = ({ image, name }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        p: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: 120,
        boxShadow: 2,
        position: "relative",
        overflow: "hidden",
        backgroundColor: theme.palette.background.paper,
        borderRadius: 1,
        border: `1px solid ${theme.palette.text.disabled}`,
        transition: "none",
        "&hover .client-name": {
          opacity: 1,
          transform: "translateY(0)",
        },
      }}
    >
      <Box
        component="img"
        src={image}
        alt={name ?? "Client logo"}
        sx={{
          maxHeight: "90px",
          maxWidth: "100%",
          objectFit: "contain",
        }}
      />
    </Box>
  );
};

export default ClientLogoCard;
